import { KeyRound, Database, ArrowLeft } from 'lucide-react';

export function ConfigRequired() {
  return (
    <main className="config-page blueprint-bg">
      <section className="config-card">
        <div className="brand-mark">TRP</div>
        <p className="eyebrow">The Rebuild Hub</p>
        <h1>Supabase is awaiting configuration.</h1>
        <p>
          This build won’t pretend authentication or member data is active. Add the project URL and anonymous key,
          run the Phase 1 migration, then restart the app.
        </p>
        <div className="config-steps">
          <div><Database size={19} /><span>Run <code>supabase/migrations/202607160001_phase1_rebuild_hub.sql</code>.</span></div>
          <div><KeyRound size={19} /><span>Add <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code>.</span></div>
        </div>
        <a className="button secondary" href={import.meta.env.VITE_PUBLIC_SITE_URL || 'https://therebuildprocess.com'}>
          <ArrowLeft size={17} /> Return to the public site
        </a>
      </section>
    </main>
  );
}
